import { AlbusUrlConfigs } from "./AlbusUrlConfigs";
import ApiUtils from "../utils/ApiUtils";
import { ICareRecommendationServiceApis } from "./ICareRecommendationServiceApis";
import { INewConfigData } from "../models/patients/IEHRSavePatientMedicalProfile";


export default class CareRecommendationServiceApis implements ICareRecommendationServiceApis {
    getDoctorWiseSubSectionRecommendations(doctorId: number, recommendationType: string, prescriptionDetails?: INewConfigData): Promise<any> {
        const url = AlbusUrlConfigs.getDoctorWiseSubSectionRecommendations(recommendationType);
        const params = { "doctor_id": doctorId, ...prescriptionDetails };
        return ApiUtils.apiPostRequest(url, JSON.stringify(params));
    }

    getInterventionRecommendations():Promise<any> {
        const url = AlbusUrlConfigs.getDoctorWiseSubSectionRecommendations("intervention-recommendation");
        return ApiUtils.apiGetRequest(url);   
    }
}

